import debounce from 'lodash/debounce'
import { ReactNode, useEffect, useRef } from 'react'

const sendHeight = (): void => {
  const gsuDocumentHeight = document.body.scrollHeight
  const message = { gsuDocumentHeight }
  console.log('sendHeight', { message })
  // Send to any page (*) that embeds this
  parent.postMessage(message, '*')
}

export const resizeHandler = debounce(sendHeight, 300) // 300ms debounce

export function EmbeddedResize({ children }: { children: ReactNode }): JSX.Element {
  const resizeContainerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    sendHeight()
    window.addEventListener('resize', resizeHandler)

    // We're also using the `ResizeObserver` API to detect when the container size
    // changes to catch any cases where we might forget to explicitly call `sendHeight()`
    // It's fine that this is also called at the same time as the `resize` window event,
    // as we're passing in the debounce function.
    const resizeContainer = resizeContainerRef.current
    const resizeObserver = new ResizeObserver(resizeHandler)
    if (resizeContainer) resizeObserver.observe(resizeContainerRef.current)

    return () => {
      window.removeEventListener('resize', resizeHandler)
      if (resizeContainer) resizeObserver.unobserve(resizeContainer)
    }
  }, [])

  return (
    <div ref={resizeContainerRef} data-resize-container>
      {children}
    </div>
  )
}
